<template>
  <div class="content">
    <Modal v-model="visible" :title="titleTxt" width="1200" class="my-modal top">
      <loading :isShow="loading" />
      <div class="form-wrap">
        <Form :model="formData" :rules="formRules" ref="formRef" :label-width="130">
          <FormItem label="名称" class="less" prop="name" key="formData.name">
            <Input
              v-model="formData.name"
              placeholder="请输入课程名称"
              @on-blur="
                event => {
                  formData.name = event.target.value.trim();
                }
              "
              :maxlength="32"
              :show-word-limit="true"
              clearable
            />
          </FormItem>
          <FormItem label="排序" class="less" prop="orderNum" key="formData.orderNum" :rules="[$units.formRule.justIntSort()]">
            <Input
              v-model="formData.orderNum"
              placeholder="请输入正整数，排序越大越靠前"
              type="number"
              @on-blur="
                event => {
                  formData.orderNum = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
          <FormItem prop="articleType" class="less" label="课程类型" key="formData.articleType">
            <Select
              :disabled="formData.parentId.length > 1 || (formData.useTime !== undefined && formData.useTime !== '')"
              v-model="formData.articleType"
              @on-change="changeForm"
            >
              <Option v-for="(item, index) in articleTypeList" :value="item.id" :key="index" :label="item.name">
                {{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem prop="articleColumnIds" class="less" label="课程分类" key="formData.articleColumnIds">
            <div style="display: flex">
              <selectTreeOld
                :disabled="formData.parentId.length > 1"
                style="width: 250px"
                :data="courseTypeList"
                :multiple="true"
                :size="null"
                placeholder="请选择"
                :single="true"
                :showParentNode="true"
                :selectAllChildren="false"
                v-model="formData.articleColumnIds"
              ></selectTreeOld>
              <span class="table-btn auto" @click="$router.push('/trainingCourse/courseMenuNew')" style="margin-left: 10px; margin-right: 0">新增分类</span>
            </div>
          </FormItem>
          <FormItem v-if="!formData.parentId || formData.parentId == 0" label="标签" class="less" prop="tagList" key="formData.tag">
            <div>
              <Tag color="primary" v-for="item in formData.tagList" :key="item" :name="item" closable @on-close="handleClose">{{ item }}</Tag>
            </div>
            <Input
              v-model="formData.tag"
              placeholder="输入标签名称并回车新增标签"
              @on-blur="
                event => {
                  formData.tag = event.target.value.trim();
                }
              "
              :maxlength="4"
              :show-word-limit="true"
              clearable
              @on-enter="addTag"
            />
          </FormItem>
          <FormItem prop="orgList" class="less" label="展示机构" key="formData.orgList">
            <span v-if="formData.parentId.length > 1 && !formData.orgList">全部</span>
            <selectTreeNew
              ref="selectTreeNewRef"
              v-model="formData.orgList"
              type="4"
              status="1"
              :disabled="formData.parentId.length > 1"
              :multiple="true"
            ></selectTreeNew>
          </FormItem>
          <FormItem label="已学人数" class="less" prop="peopleNumConfig" key="formData.peopleNumConfig" :rules="$units.formRule.IntSort()">
            <Input v-model="formData.peopleNumConfig" placeholder="请输入已学人数" number clearable></Input>
          </FormItem>
          <FormItem v-if="visibility.indexOf('trainingTime') !== -1" label="阅读时长(分钟)" class="less" prop="trainingTime" key="formData.trainingTime" :rules="$units.formRule.IntSort()">
            <Input v-model="formData.trainingTime" placeholder="请输入阅读时长" number clearable></Input>
          </FormItem>
          <FormItem v-if="!formData.parentId || formData.parentId == 0" label="封面" class="less" prop="coverImg" key="formData.coverImg">
            <upload :muti="false" :arr="formData.coverImg" @remove="removeFile()" @upload="toloadFile" tip="图片尺寸为180x220" />
          </FormItem>
          <FormItem v-if="!formData.parentId || formData.parentId == 0" label="摘要" class="less" prop="description" key="formData.description">
            <Input v-model="formData.description" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入摘要……" />
          </FormItem>
          <FormItem v-if="visibility.indexOf('liveUrl') !== -1" label="直播地址" class="less" prop="liveUrl" key="formData.liveUrl">
            <Input
              v-model="formData.liveUrl"
              placeholder="请输入直播地址"
              @on-blur="
                event => {
                  formData.liveUrl = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
          <FormItem v-if="visibility.indexOf('liveBeginTime') !== -1" label="直播时间" class="less" prop="liveBeginTime" key="formData.liveBeginTime">
            <DatePicker
              type="datetime"
              transfer
              format="yyyy-MM-dd HH:mm"
              split-panels
              placement="top"
              v-model="formData.liveBeginTime"
              placeholder="请选择"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
          <FormItem
            v-if="formData.articleType == 2"
            label="上传视频"
            class="less"
            prop="url"
            :rules="[
              {
                required: true,
                message: ' 请上传视频',
                trigger: 'change'
              }
            ]"
            key="formData.url"
          >
            <uploadVideo :url="formData.url" file-type=".mp4" @upload="uploadUrl"></uploadVideo>
          </FormItem>
          <FormItem v-if="formData.articleType == 3" label="上传视频" class="less" prop="url" key="formData.url1">
            <uploadVideo :url="formData.url" file-type=".mp4" @upload="uploadUrl"></uploadVideo>
          </FormItem>
          <FormItem v-if="formData.articleType == 3 || formData.articleType == 2" label="上传课件" class="less" prop="courseUrl" key="formData.courseUrl">
            <uploadVideo :url="formData.courseUrl" file-type=".pdf" btn-val="上传课件" @upload="uploadCourseUrl"> </uploadVideo>
          </FormItem>
          <FormItem v-if="visibility.indexOf('fileUrl') !== -1" label="上传文件" class="less" prop="fileUrl" :rules="$units.formRule.required('请上传')">
            <Upload multiple action="/" :before-upload="handleUpload" :show-upload-list="false">
              <Button class="upload-btn" style="color: #236dff; border: 1px solid #eaf2ff; background: #f5f8ff">上传文件</Button>
            </Upload>

            <div class="upload-box" v-for="(item, index) in pdfList" :key="index">
              <img class="icon-del" @click.stop="delPdfList(index)" src="@static/images/operate/close.png" alt="" />
              <div class="flex">
                <div class="excel-icon" v-if="formData.articleType == 5"></div>
                <div class="icon-type" v-else></div>
                <div>
                  <p class="name">{{ item.fileName }}</p>
                  <p class="size">{{ item.sizeStr }}</p>
                </div>
              </div>
            </div>
          </FormItem>
          <FormItem
            v-if="formData.articleType != 4 && formData.articleType != 5 && formData.parentId.length < 2"
            label="内容"
            class="full"
            prop="content"
            key="formData.content"
            :rules="formData.articleType == 2 ? { required: false } : $units.formRule.required('请输入')"
          >
            <editor ref="editorRef" v-model="formData.content"></editor>
          </FormItem>
        </Form>
      </div>
      <div class="ivu-modal-footer" slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="confirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { uploadFile } from '@/api/httpList';
import upload from '@/components/commons/upload';
import uploadVideo from './uploadFile';
import editor from '@/components/commons/editor';
import selectTree from '@/components/system/selectTree2';
import selectTreeOld from '@/components/commons/selectTree';
import selectTreeNew from '@/components/system/selectTree3';
export default {
  components: {
    upload,
    selectTree,
    selectTreeOld,
    selectTreeNew,
    editor,
    uploadVideo
  },
  data() {
    return {
      articleTypeList: [
        {
          id: '1',
          name: '图文'
        },
        {
          id: '2',
          name: '视频'
        },
        {
          id: '3',
          name: '直播'
        },
        {
          id: '4',
          name: 'PDF'
        },
        {
          id: '5',
          name: 'Excel'
        }
      ],
      courseTypeList: [], //课程分类
      visible: false,
      loading: false,
      isUpload: false,
      tagList: [],
      formData: {
        id: '',
        parentId: '', //父课程id
        name: '', //名称
        orderNum: '', //排序
        articleType: '1', //类型（1-图文2-视频3-直播4-pdf）
        articleColumnIds: [], //课程分类id ,Long
        tagList: [],
        tag: '', //标签
        orgList: '', //适用机构id ,Long 全部机构的时候不传值
        coverImg: '', //封面
        description: '', //简介
        url: '', //视频地址
        videoLength: '', //视频时长
        fileUrl: null, //文件地址
        fileSize: '', //文件大小
        courseUrl: '', //课件地址
        liveUrl: '', //直播链接
        liveBeginTime: '', //直播开始时间
        content: '', //富文本内容
        peopleNumConfig:'',//已学人数
        trainingTime: '' //阅读时长
      }, // 协议文件列表
      pdfList: [],
      formRules: {
        tagList: [
          {
            required: true,
            message: '请输入',
            trigger: 'change',
            type: 'array'
          }
        ],
        orgList: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            type: 'array'
          }
        ],
        fileUrl: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'change',
            type: 'object',
            validator: (rule, value, callback) => {
              if (!value.url || value.url == '') {
                //写逻辑从而达到验证值
                callback(new Error('请上传文件')); //callback（）暂时理解为回调，验证后回调给界面的信息
              } else {
                callback(); //默认回调，没有异常值
              }
            }
          }
        ],
        coverImg: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'change'
          }
        ],
        articleColumnIds: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            type: 'array'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        articleType: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ]
      },
      formVisibilityMap: {
        1: ['id', 'parentId', 'name', 'orderNum', 'articleType', 'articleColumnIds', 'tag', 'orgList', 'coverImg', 'description', 'content', 'trainingTime'],
        2: [
          'id',
          'parentId',
          'name',
          'orderNum',
          'articleType',
          'articleColumnIds',
          'tag',
          'orgList',
          'coverImg',
          'description',
          'content',
          'url',
          'courseUrl',
          'videoLength'
        ],
        3: [
          'id',
          'parentId',
          'name',
          'orderNum',
          'articleType',
          'articleColumnIds',
          'tag',
          'orgList',
          'coverImg',
          'description',
          'content',
          'liveUrl',
          'liveBeginTime',
          'url',
          'courseUrl',
          'videoLength'
        ],
        4: [
          'id',
          'parentId',
          'name',
          'orderNum',
          'articleType',
          'articleColumnIds',
          'tag',
          'orgList',
          'coverImg',
          'description',
          'fileUrl',
          'fileSize',
          'trainingTime'
        ],
        5: [
          'id',
          'parentId',
          'name',
          'orderNum',
          'articleType',
          'articleColumnIds',
          'tag',
          'orgList',
          'coverImg',
          'description',
          'fileUrl',
          'fileSize',
          'trainingTime'
        ]
      },
      visibility: ['parentId', 'name', 'orderNum', 'articleType', 'articleColumnIds', 'tag', 'orgList', 'coverImg', 'description', 'content', 'trainingTime'],
      titleTxt: '', // 标题
      showOrgIdsArr: []
    };
  },
  methods: {
    // 默认勾选展示机构
    getOrgTreeData(data) {
      if (!this.formData.id) {
        this.$set(this.formData, 'orgList', this.dealTree(data));
      }
    },

    // 得到树结构id，组成新数组
    dealTree(arr) {
      arr.forEach(item => {
        this.showOrgIdsArr.push(item.id);
        if (item.children) {
          this.dealTree(item.children);
        }
      });
      return this.showOrgIdsArr;
    },
    addTag() {
      if (this.formData.tagList.length >= 3) {
        return this.$notice.error('最多有三个标签');
      }
      if (!this.formData.tag) {
        return this.$notice.error('请输入标签名');
      }
      this.formData.tagList.push(this.formData.tag);
      this.formData.tag = '';
    },
    handleClose(event, name) {
      const index = this.formData.tagList.indexOf(name);
      let arr = this.formData.tagList
      arr.splice(index, 1)
      console.log(arr)
      this.formData = {
        ...this.formData,
        tagList:arr
      }
    },
    uploadUrl(res) {
      if (res.url) {
        this.$notice.success('操作成功');
      }
      this.formData.url = res.url;
      this.formData.videoLength = parseInt(res.second);
      this.$refs.formRef.validateField('url'); // 清除表单校验：文件
    },
    uploadCourseUrl(res) {
      if (res.url) {
        this.$notice.success('操作成功');
      }
      this.formData.courseUrl = res;
      this.$refs.formRef.validateField('courseUrl'); // 清除表单校验：文件
    },
    changeForm(val) {
      //更改表单结构
      this.visibility = this.formVisibilityMap[val];
      for (let key in this.formData) {
        if (this.visibility.indexOf(key) == -1) {
          if (key == 'articleColumnIds' || key == 'tagList') {
            this.formData[key] = [];
          } else {
            this.formData[key] = '';
          }
        }
      }
    },
    open(item) {
      this.showOrgIdsArr = [];
      for (let key in this.formData) {
        if (key == 'articleType') {
          this.formData[key] = '1';
        } else if (key == 'articleColumnIds') {
          this.formData[key] = [];
        } else if (key == 'courseUrl' || key == 'fileUrl') {
          this.formData[key] = {};
        } else if (key == 'content') {
          this.formData[key] = '';
          this.$refs.editorRef && this.$refs.editorRef.initHtml('');
        } else {
          this.formData[key] = '';
        }
      }
      this.formData.tagList = [];
      if (item.id) {
        this.formData.id = item.id;
        this.getDetail();
      } else if (item.parentId) {
        this.formData = {
          ...this.formData,
          ...item
        };
        this.visibility = this.formVisibilityMap[item.articleType];
      } else {
        this.visibility = this.formVisibilityMap[1];
      }
      this.getCourseColumn();
      this.titleTxt = item.id ? '编辑' : item.parentId ? '新增子课程' : '新增';
      this.visible = true;
      setTimeout(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.init();
      }, 0);

      this.$nextTick(() => {
        this.$refs.selectTreeNewRef && this.$refs.selectTreeNewRef.openChange();
      });
    },
    getCourseColumn() {
      this.$http({
        url: `/buz/courseColumn/read/list`,
        type: 'POST',
        data: {
          pageSize: 999,
          pageNo: 1
        }
      }).then(res => {
        this.courseTypeList = this.dealTree(res.data);
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },

    // 移除文件
    removeFile() {
      this.formData.coverImg = '';
    },
    // 上传
    toloadFile(file) {
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.formData.coverImg = res.data[0].path;
        this.$refs.formRef.validateField('coverImg'); // 清除表单校验：文件
      });
    },
    // 详情
    getDetail() {
      this.$http({
        url: `/buz/course/read/detail`,
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        if (res.data.trainingTime) {
          res.data.trainingTime = res.data.trainingTime / 60;
        }
        if (res.data.courseUrl) {
          try {
            res.data.courseUrl = JSON.parse(res.data.courseUrl);
          } catch (e) {
            res.data.courseUrl = {
              url: res.data.courseUrl,
              fileName: res.data.courseUrl.split('/').pop()
            };
          }
        }
        if (res.data.fileUrl && res.data.articleType != 4) {
          try {
            res.data.fileUrl = JSON.parse(res.data.fileUrl);
          } catch (e) {
            res.data.fileUrl = {
              url: res.data.fileUrl,
              fileName: res.data.fileUrl.split('/').pop()
            };
          }
        }
        if (res.data.articleType == 4) {
          this.pdfList = JSON.parse(res.data.fileUrl);
          this.formData.fileUrl = res.data.fileUrl;
        }
        if (res.data.articleType == 5) {
          this.pdfList = res.data.fileUrl;
        }
        if (res.data.tag) {
          res.data.tagList = res.data.tag.split(',');
          res.data.tag = '';
        } else {
          res.data.tagList = [];
        }
        this.formData = res.data;
        this.visibility = this.formVisibilityMap[res.data.articleType || 1];
      });
    },
    confirm() {
      this.$refs['formRef'].validate(valid => {
        const formData = JSON.parse(JSON.stringify(this.formData))
        let trainingTime = '';
        let tag = '';
        if (formData.trainingTime) {
          trainingTime = formData.trainingTime * 60;
        }
        if (formData.courseUrl && Object.keys(formData.courseUrl).length) {
          formData.courseUrl = JSON.stringify(formData.courseUrl);
        }
        if (formData.courseUrl && !Object.keys(formData.courseUrl).length) {
          delete formData.courseUrl;
        }
        if (formData.fileUrl && !Object.keys(formData.fileUrl).length) {
          delete formData.fileUrl;
        }
        if (formData.tagList && formData.tagList.length) {
          tag = formData.tagList.join();
        }
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            url: `/buz/course/edit`,
            type: 'POST',
            data: {
              ...formData,
              trainingTime,
              tag
            },
            apiPermissionCode: 'operate_3_1_1'
          })
            .then(res => {
              this.$notice.success(this.formData.id ? '修改成功' : '新增成功');
              this.visible = false;
              this.$emit('reload');
            })
            .finally(() => {
              window.setTimeout(() => {
                this.loading = false;
              }, 500);
            });
        }
      });
    },
    handleUpload(file) {
      if (file.size) {
        file.sizeStr = file.size / 1024 > 1024 ? (file.size / 1024 / 1024).toFixed(1) + 'M' : (file.size / 1024).toFixed(1) + 'KB';
      }
      this.file = file;
      let reg = null;
      let msg = null;
      if (this.formData.articleType != 5) {
        reg = /\.(pdf)$/;
        msg = '上传格式不正确，请上传PDF文件';
      } else {
        reg = /\.(xlsx|xls)$/;
        msg = '上传格式不正确，请上传Excel文件';
      }
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(msg);
        return false;
      }
      this.isUpload = true;
      let formData = new FormData();
      formData.append('file', file);
      if (this.fileType == '.mp4') {
        this.uploadVideo(formData);
      } else {
        this.uploadFileFn(formData, file);
      }
      return false;
    },
    uploadFileFn(formData, file) {
      uploadFile(formData, e => {})
        .then(res => {
          res.data.map(item => {
            item.sizeStr = file.sizeStr;
            item.url = item.path;
            delete item.path;
          });
          this.pdfList = [...this.pdfList, ...res.data];
          this.formData.fileUrl = JSON.stringify(this.pdfList);
        })
        .catch(e => {
          this.$notice.success('上传失败');
          this.isUpload = false;
        });
    },
    delPdfList(index) {
      this.pdfList.splice(index, 1);
      if (!this.pdfList.length) {
        this.formData.fileUrl = '';
      } else {
        this.formData.fileUrl = JSON.stringify(this.pdfList);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-wrap {
  max-width: 250px;
  margin-left: 0;
}
.upload-box {
  width: 260px;
  height: 80px;
  background: #fafafa;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e5e8;
  position: relative;
  padding-top: 15px;
  margin: 10px 0;

  .flex {
    display: flex;
    align-items: center;
  }

  .icon-type {
    width: 43px;
    height: 43px;
    background: #ffffff;
    margin: 0 6px 0 10px;
    cursor: pointer;
    background: url('~@static/images/cc_pdf_new.png') no-repeat;
    background-size: 43px;
    position: relative;

    .eyes {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      line-height: 43px;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      text-align: center;

      .ivu-icon {
        color: #fff;
        font-size: 18px;
        cursor: pointer;
      }
    }

    &:hover {
      .eyes {
        display: block;
      }
    }
  }
  .excel-icon {
    width: 43px;
    height: 43px;
    background: #ffffff;
    margin: 0 6px 0 10px;
    cursor: pointer;
    background: url('~@static/images/cc_excel.png') no-repeat;
    background-size: 43px;
    position: relative;
  }

  .icon-del {
    position: absolute;
    cursor: pointer;
    width: 10px;
    height: 10px;
    top: 6px;
    right: 6px;
  }

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 169px;
    white-space: nowrap;
    font-size: 14px;
    color: #515c6f;
    line-height: 20px;
  }

  .size {
    display: block;
    font-size: 12px;
    color: #a8adb7;
    margin-top: 4px;
    line-height: 17px;
  }

  /deep/.ivu-progress {
    width: calc(100% - 25px);
    margin-left: 10px;
    line-height: 1;
  }

  /deep/.ivu-progress-success .ivu-progress-bg {
    background-color: #236dff;
  }
}

.form-wrap {
  margin-top: 10px;

  .all {
    position: absolute;
    left: 10px;
    top: 0;
    height: 20px;
    background-color: #fff;
    font-size: 14px;
    color: #3c464f;
  }

  .ivu-form {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/.ivu-form-item-error-tip {
    top: unset;
  }

  /deep/.ivu-input-suffix {
    right: 4px;
  }

  /deep/ .ivu-form-item-label {
    word-break: keep-all;
    line-height: 32px;
    padding: 0 12px 0 0;
  }

  /deep/ .ivu-form-item {
    width: 33.333333%;
    padding-right: 30px;
    vertical-align: top;
    margin: 0;
    display: flex;
    margin-bottom: 25px;

    &.less {
      width: 50%;
    }

    &.two {
      width: 66.666666%;
    }

    &.full {
      width: 100%;
    }

    &.four {
      width: 25%;
    }

    &.big-label {
      .ivu-form-item-label {
        white-space: nowrap;
        float: none;
      }

      .ivu-form-item-content {
        display: inline-block;
        margin-left: 0 !important;
      }
    }
  }

  /deep/ .ivu-form-item-content {
    width: 100%;
    line-height: 32px;
    margin-left: 0 !important;

    > div {
      width: 100%;
    }

    .ivu-input {
      width: 100%;
    }
  }

  .btn-upload {
    display: inline-block;
    width: 88px;
    height: 32px;
    background: #f5f8ff;
    border-radius: 2px;
    border: 1px solid #eaf2ff;
    cursor: pointer;
    font-size: 14px;
    color: #236dff;
    line-height: 32px;
    text-align: center;
  }

  /deep/.uploadBoxs {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    img {
      width: 145px;
      height: 94px;
    }
  }

  textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #dcdee2;
    outline: none;
    padding: 10px;
    resize: none;
    border-radius: 4px;
  }
}

.form-wrap {
  &::v-deep {
    .ivu-form-item {
      .ivu-form-item-content {
        width: calc(100% - 100px) !important;
      }
    }
  }
}

/deep/.ivu-modal-footer {
  z-index: 10001 !important;
}
</style>
